import { useState } from "react";
import "./scorecardInstructions.css";
import "../../index.css";
import ScorecardHomeSubHeader from "./ScorecardHome/scorecardHomeSubHeader";
import PopUpScorecardFormDownloadScorecard from "../../popUpForms/popUpScorecardFormDownloadScorecard";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";

const ScorecardInstructions = () => {
  const [formActiveState, setFormActiveState] = useState(false);

  const handleShowDownloadScorecardFormPopUp = () => {
    setFormActiveState(true);
  };

  return (
    <>
      <ScorecardHomeSubHeader />
      <div className="scorecard-instructions">
        <h1> Instructions</h1>
        <p>
          The Scorecard can be downloaded{" "}
          <span
            className="click-to-scorecard-form"
            onClick={handleShowDownloadScorecardFormPopUp}
          >
            here
          </span>{" "}
          and contains three documents: instructions, spreadsheet, and a pdf
          file.
        </p>
        <p>
          Once you have downloaded the Scorecard, you can fill out the scorecard
          individually or, most likely, you will form a group to go through and
          complete the scorecard together. You can fill out questions that are
          relevant to you. We do encourage everyone to view the questions and
          have a holistic approach to address what else may be considered to
          achieve a safe, healthy and resilient community. View{" "}
          <a href="/scorecard/faq">Frequently Asked Questions</a>.
        </p>
        <p>
          <img
            src="/assets/content/scorecardInfographicMain.png"
            alt="Scorecard Infographic"
          />
        </p>
      </div>

      <PopUpModal
        activeForm="scorecard-download"
        formActiveState={formActiveState}
        setFormActiveState={setFormActiveState}
      >
        <PopUpScorecardFormDownloadScorecard />
      </PopUpModal>
    </>
  );
};

export default ScorecardInstructions;
